import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./Home.module.css";

import {
  categoryImages,
  brands,
  certificates,
  statsData,
  references,
} from "./homeData";

import Slider from "./Slider/Slider";
import SlideContent from "./Slider/components/SlideContent";
import Brands from "./Brands/Brands";
import Certificates from "./Certificates/Certificates";
import Stats from "./Stats/Stats";
import MapSection from "./MapSection/MapSection";
import References from "./References/References";
import useLocalizedPath from "../../hooks/useLocalizedPath";

const Home = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const localizedPath = useLocalizedPath();

  // Transform categoryImages into the format expected by the new slider
  const slides = categoryImages.map(item => ({
    title: t(`home.categories.${item.name}.name`),
    description: t(`home.categories.${item.name}.description`),
    category: item.category,
    videoUrl: item.image,
    webmUrl: item.webm,
    mobileImage: item.mobileImage,
    mobileWebm: item.mobileWebm,
    poster: item.poster
  }));

  return (
    <div className={styles.homeContainer}>
      <section className={styles.sectionWrapper} data-aos="fade-right" data-aos-duration="800">
        <Slider slides={slides} />
      </section>
      <section className={styles.sectionWrapper} data-aos="fade-left" data-aos-delay="200">
        <Brands items={brands} />
      </section>
      <section className={styles.sectionWrapper} data-aos="fade-up" data-aos-delay="400">
        <Certificates items={certificates} />
      </section>
      
      {/* CATALOG & DOCUMENTS CTA */}
      <section className={styles.sectionWrapper} data-aos="fade-right" data-aos-delay="600">
        <div className={styles.ctaContainer}>
          <p className={styles.ctaText}>
            {t('home.cta.text')}
          </p>
          <div className={styles.ctaButtons}>
            <button
              className={styles.ctaButton}
              onClick={() => navigate(localizedPath('/catalog'))}
            >
              <i className="fas fa-book-open" /> {t('home.cta.catalogs')}
            </button>
            <button
              className={styles.ctaButton}
              onClick={() => navigate(localizedPath('/documents'))}
            >
              <i className="fas fa-file-alt" /> {t('home.cta.documents')}
            </button>
          </div>
        </div>
      </section>
      <section className={styles.sectionWrapper} data-aos="fade-left" data-aos-delay="800">
        <Stats data={statsData} />
      </section>
      <section className={styles.sectionWrapper} data-aos="fade-up" data-aos-delay="1000">
        <MapSection />
      </section>
      <section className={styles.sectionWrapper} data-aos="fade-up">
        <References references={references} />
      </section>
    </div>
  );
};

export default Home;
